import React, { Suspense, useState } from "react";
import {
  AppBar,
  Box,
  IconButton,
  Toolbar,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import { Outlet } from "react-router-dom";
import LoadingSpinner from "../components/LoadingSpinner";

import { GARAGE_ROLE } from "../constants";
import WorkshopAdminDrawer from "../sections/header/WorkshopAdminDrawer";

const drawerWidth = 240;

interface IPROPS {
  liftingName: any;
}

const WorkshopAdminMasterLayout: React.FC<IPROPS> = ({ liftingName }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const isGarageAdminLoggedIn = localStorage.getItem(GARAGE_ROLE);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: "flex" }}>
      {/* AppBar */}
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          width: isMobile ? "100%" : `calc(100% - ${drawerWidth}px)`,
          ml: isMobile ? 0 : `${drawerWidth}px`,
          backgroundColor: "#fff",
          color: "#1e1e1e",
          height: "80px",
          transition: "all 0.3s ease",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between", height: "80px" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            {/* Menu button only on mobile */}
            {isMobile && (
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                onClick={handleDrawerToggle}
              >
                <MenuIcon />
              </IconButton>
            )}
            <Typography
            variant="h6"
              sx={{
                color: "#181C32",
                fontSize: "24px",
              }}
              style={{fontFamily:'karbon', fontWeight:200 }}
            >
              {isGarageAdminLoggedIn === "garage_tenant_admin"
                ? "Admin"
                : "Workshop Admin"}
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Drawer */}
      <WorkshopAdminDrawer
        mobileOpen={mobileOpen}
        onMobileClose={handleDrawerToggle}
      />

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "#f3f4f6",
          p: 3,
          minHeight: "100vh",
          mt: "80px", // below AppBar
          transition: "all 0.3s ease",
        }}
      >
        <div className="post d-flex flex-column-fluid" id="kt_post">
          <div id="kt_content_container" className="w-100">
            <Suspense fallback={<LoadingSpinner />}>
              <Outlet />
            </Suspense>
          </div>
        </div>
      </Box>
    </Box>
  );
};

export default WorkshopAdminMasterLayout;
